import { Grid as MUIGrid2 } from '@mui/material';

/**
 * Project alias for MUI's Grid (the v2 grid). Use this instead of importing
 * `Grid` from `@mui/material` so the whole app tracks one grid implementation.
 * All MUI Grid props (`container`, `size`, `spacing`, ...) pass through.
 */
const Grid = props => <MUIGrid2 {...props} />;

export default Grid;
